import React from 'react'
import { gql, useMutation } from '@apollo/client'
import { useSnackbar } from 'notistack'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Link from '@material-ui/core/Link'
import Dialog from 'components/dialog'
import { useDialogTitleStyles } from 'components/dialog/use-dialog-title-styles'
import EventBusyOutlinedIcon from 'components/material-symbol/icons/EventBusy'
import { useAuth } from 'lib/auth'
import { MY_PGA_COM_HOST } from 'env'

const CANCEL_ENROLLMENT = gql`
  mutation CancelEnrollment($input: CancelEnrollmentInput!) {
    cancelEnrollment(input: $input) {
      success
      message
    }
  }
`

const CancelBookingDialog = ({
  trigger,
  confirmationCode,
  onSuccess,
  onConfirm,
}) => {
  const classes = useDialogTitleStyles()
  const [cancelEnrollment, { loading }] = useMutation(CANCEL_ENROLLMENT)
  const { enqueueSnackbar } = useSnackbar()
  const { isConsumer } = useAuth()

  return (
    <Dialog
      trigger={trigger}
      maxWidth="xs"
      fullWidth
      showCloseButton
      disableClose={loading}
      classes={{ paper: classes.dialogPaper }}
    >
      {({ closeDialog }) => {
        const onCancelBookingConfirm = () => {
          onConfirm && onConfirm()
          cancelEnrollment({
            variables: { input: { confirmationCode } },
          }).then(({ data }) => {
            if (data.cancelEnrollment.success) {
              enqueueSnackbar('Session canceled', { variant: 'success' })
              closeDialog()
              onSuccess && onSuccess()
            } else {
              enqueueSnackbar(data.cancelEnrollment.message, {
                variant: 'error',
              })
            }
          })
        }
        return (
          <>
            <DialogTitle
              disableTypography
              classes={{ root: classes.titleRoot }}
            >
              <Typography component="h2" className={classes.title}>
                Cancel
              </Typography>
              <Typography className={classes.bodyText}>
                {isConsumer
                  ? 'Are you sure you want to cancel? Your coach will be notified.'
                  : 'Are you sure you want to cancel? All students will be notified.'}
              </Typography>
            </DialogTitle>
            <DialogContent classes={{ root: classes.content }}>
              <Typography className={classes.bodyText}>
                {isConsumer ? (
                  'For any applicable refund, please reach out to your Coach.'
                ) : (
                  <>
                    Refunds are not issued automatically. If needed, you can
                    issue a refund from the student&apos;s{' '}
                    <Link
                      href={`${MY_PGA_COM_HOST}/account/payments/transactions`}
                      style={{ fontWeight: 600 }}
                      target="_blank"
                    >
                      Transaction Details
                    </Link>
                    .
                  </>
                )}
              </Typography>
            </DialogContent>
            <DialogActions className={classes.actions}>
              <Button
                color="primary"
                size="large"
                onClick={closeDialog}
                disabled={loading}
              >
                Keep Session
              </Button>
              <Button
                color="primary"
                variant="contained"
                size="large"
                disableElevation
                startIcon={<EventBusyOutlinedIcon fontSize="small" fill={0} />}
                onClick={onCancelBookingConfirm}
                disabled={loading}
              >
                Cancel Session
              </Button>
            </DialogActions>
          </>
        )
      }}
    </Dialog>
  )
}

export default CancelBookingDialog
